<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <Avatar :label="label.toUpperCase()" />
      </CHeaderNavLink>
    </template>

    <span v-for="(section, index) in sections" :key="index">
      <CDropdownHeader
        tag="div"
        class="text-center"
        color="light"
      >
        <strong>{{ section.label.toUpperCase() }}</strong>
      </CDropdownHeader>
      <CDropdownItem  
        v-for="(item, itemIndex) in section.items"
        :key="itemIndex"
        :to="item.to"
      >
        <CIcon :name="item.icon" /> <span class="mr-3">{{ item.label }}</span>
        <CBadge :color="item.badgeColor" class="mfs-auto">{{ item.badgeLabel }}</CBadge>
      </CDropdownItem>
    </span>

    <CDropdownDivider/>
    <CDropdownItem to="/admin" v-if="isAdminUser">
      <CIcon name="cil-speedometer" /> Admin
    </CDropdownItem>
    <CDropdownItem @click="logout">
      <CIcon name="cil-lock-locked" /> Logout
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Avatar from './Avatar'

export default {
  name: 'AccountDropdown',
  components: {
    Avatar
  },
  props: {
    label: String
  },
  methods: {
    ...mapActions('auth', {
      authLogout: 'logout'
    }),
    logout () {
      this.authLogout()
      if (this.$router.currentRoute.path !== '/') this.$router.push('/')
    },
  },
  computed: {
    ...mapGetters('auth', [
      'isAdminUser'
    ]),
    sections () {
      return this.$store.state.navigation.sections
    }
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>